<template>
  <div v-if="companyInformation" class="login-screen">
    <img :src="logo" :alt="companyInformation.logo_name" class="logo" />
    <h1>Welcome to {{ companyInformation.product_name }}</h1>
    <div class="limitation-item">
      {{ companyInformation.copyright_disclaimer }}
    </div>
    <button @click="login" class="unstyled-button">
      <img :src="loginButtonImage" alt="Sign in with Microsoft" />
    </button>
  </div>
</template>

<script>
import { getCurrentTheme } from '@/utils/themeManager';

export default {
  name: 'LoginScreen',
  props: {
    companyInformation: Object
  },
  data() {
    return {
      loginButtonImage: null,
      logo: null,
      currentTheme: getCurrentTheme(),
    };
  },
  watch: {
    // Watch for when companyInformation becomes available
    companyInformation: {
      handler(newVal) {
        if (newVal) {
          this.updateLogo();
          this.updateHtmlHeader();
        }
      },
      immediate: true
    }
  },
  methods: {
    updateLogo() {
      // Ensure companyInformation is available before updating logo
      if (!this.companyInformation) {
        return;
      }

      // Select correct logo based on current theme
      if (getCurrentTheme().includes('dark')) {
        this.logo = this.companyInformation.logo_dark_mode;
        this.loginButtonImage = require('@/assets/icons/ms-symbollockup_signin_dark.svg');
      } else {
        this.logo = this.companyInformation.logo;
        this.loginButtonImage = require('@/assets/icons/ms-symbollockup_signin_light.svg');
      }
    },
    login() {
      this.$emit('login'); // Emit a login event to the parent component
    },
    updateHtmlHeader() {
      const favicon = document.getElementById('favicon');
      const siteTitle = document.getElementById('siteTitle');
      if (favicon && this.companyInformation.favicon) {
        favicon.href = this.companyInformation.favicon;
      }
      if(siteTitle && this.companyInformation.product_name)
      {
        siteTitle.innerHTML = this.companyInformation.product_name;
      }
    }
  }
};
</script>

<style scoped>
.login-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-family: TT Ramillas Trl, Inter, sans-serif;
}

.logo {
  width: 6rem;
  height: auto;
  margin-bottom: 5px;
}

.unstyled-button {
  all: unset;
  cursor: pointer;
}

.limitation-item {
  max-width: 45em;
  background: #F7F9FB;
  border-radius: 8px;
  padding: 14px 18px;
  color: #1C1C1C;
  font-size: 14px;
  font-family: Inter, sans-serif;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 1em;
}

h1 {
  font-size: 24px;
  color: var(--text-primary);
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  color: var(--text-tertiary);
  margin-bottom: 20px;
}
</style>

